<ng-container *ngIf="noticias">
  <div class="row columns-2">
    <ng-container *ngFor="let item of noticias; let i = index">
      <article class="noticia col_multi_{{ i }}" ngClass="{{ item?.colorFondo ? 'noticia-color' : '' }}" [ngClass]="idStart === 0 && i === 0 ? 'first-new' : ''" [ngStyle]="item?.colorFondo && { 'background-color': item?.colorFondo }">
        <a [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">
          <ng-container *ngIf="item?.portada_iframe !== '1'">
            <ng-container *ngIf="idStart === 0 && i === 0">
              <h2 class="header-article tituloArriba" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                <ng-container *ngIf="!item?.tituloVideoSecundario">
                  {{ item?.tituloVideo }}
                </ng-container>
                <ng-container *ngIf="item?.tituloVideoSecundario">
                  {{ item?.tituloVideoSecundario }}
                </ng-container>
              </h2>
            </ng-container>
            <div style="position: relative; width: 100%">
              <ng-container *ngIf="item?.texto_etiqueta">
                <div
                  class="etiqueta et-m"
                  [ngClass]="item?.class_etiqueta"
                  [ngStyle]="{
                    color: item?.color_texto_etiqueta,
                    'background-color': item?.color_fondo_etiqueta,
                  }"
                >
                  <span class="etiquetaTxt">{{ item?.texto_etiqueta }}</span>
                </div>
              </ng-container>
              <app-skeleton-image [created]="item?.fechaCreacion" [size]="480" [src]="item?.urlGenerica" [lazy]="lcp" [aspectRatio]="'97 / 55'" [alt]="item?.tituloVideo" [pixelSrc]="item?.pixelPortadaSrc" [pixelAlt]="item?.pixelPortadaAlt"></app-skeleton-image>
              <ng-container *ngIf="item?.hasVideo">
                <app-animacion-video style="top: 0" class="animacion-video" [videoCargando]="false" [click]="false"></app-animacion-video>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="item?.portada_iframe_url && item?.portada_iframe === '1'">
            <ng-container *ngIf="item?.tituloInvisible == '0'">
              <h2 class="header-article" [ngClass]="idStart === 0 && i === 0 ? 'tituloAbajo' : ''" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                <ng-container *ngIf="!item?.tituloVideoSecundario">
                  {{ item?.tituloVideo }}
                </ng-container>
                <ng-container *ngIf="item?.tituloVideoSecundario">
                  {{ item?.tituloVideoSecundario }}
                </ng-container>
              </h2>
            </ng-container>
            <iframe [src]="item?.portada_iframe_url | safeResourceUrl" width="100%" height="380"></iframe>
          </ng-container>
          <div class="normal_new_content">
            <ng-container *ngIf="item?.tituloInvisible == '0'">
              <h2 class="header-article tituloAbajo" [ngStyle]="item?.colorTitulo && { color: item?.colorTitulo }">
                <ng-container *ngIf="!item?.tituloVideoSecundario">
                  {{ item?.tituloVideo }}
                </ng-container>
                <ng-container *ngIf="item?.tituloVideoSecundario">
                  {{ item?.tituloVideoSecundario }}
                </ng-container>
              </h2>
            </ng-container>
            <div class="footer-article">
              <ng-container *ngIf="!item?.noticias_relacionadas">
                <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && item?.firma_externa">
                  <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.firma_externa }}</span>
                </ng-container>

                <ng-container *ngIf="!item?.nombre_agencia && item?.autor_anonimo == 0 && !item?.firma_externa">
                  <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ item?.nombre_autor }}</span>
                </ng-container>

                <ng-container *ngIf="item?.nombre_agencia || item?.autor_anonimo == 1 || !item?.nombre_autor">
                  <ng-container *ngIf="!item?.firma_externa">
                    <span class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">{{ autorEmpresa }}</span>
                  </ng-container>
                </ng-container>
                <span *ngIf="showFecha" [ngStyle]="item?.colorFondo && { color: item?.colorFecha }">{{ formatDate(item?.fecha) | date: "dd/MM/yyyy" }}</span>
              </ng-container>
              <ng-container *ngIf="item?.noticias_relacionadas">
                <ng-container *ngFor="let relacionada of item?.noticias_relacionadas; trackBy: trackByNoticia">
                  <div class="canal-noticia" [ngStyle]="item?.colorFirma && { color: item?.colorFirma }">
                    <a [routerLink]="['/noticias', relacionada.idVideo, relacionada.titulo_seo | kebabCase]">
                      {{ relacionada.titulo }}
                    </a>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <p class="description-article" [innerHTML]="item?.entradillaVideo" [ngStyle]="item?.colorEntradilla && { color: item?.colorEntradilla }"></p>
          </div>
        </a>
      </article>
    </ng-container>
  </div>
</ng-container>
